import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useSession } from "@/lib/auth-client";
import { formatTimestampDate } from "@/lib/format";

/** Read-only summary of the signed-in user's account details. */
export function ProfileInfoCard() {
  const { data: session } = useSession();
  const user = session?.user;
  if (!user) return null;

  const fields: { label: string; value: React.ReactNode }[] = [
    { label: "Name", value: user.name || "—" },
    { label: "Email", value: user.email },
    {
      label: "Role",
      value: (
        <Badge variant={user.role === "admin" ? "default" : "secondary"} className="capitalize">
          {user.role ?? "user"}
        </Badge>
      ),
    },
    {
      label: "Email verified",
      value: user.emailVerified ? "Yes" : "No",
    },
    { label: "Member since", value: formatTimestampDate(user.createdAt) },
  ];

  return (
    <Card className="border-border/50">
      <CardHeader>
        <CardTitle>Account details</CardTitle>
        <CardDescription>Your basic account information.</CardDescription>
      </CardHeader>
      <CardContent>
        <dl className="divide-y divide-border/50">
          {fields.map((field) => (
            <div
              key={field.label}
              className="flex items-center justify-between gap-4 py-3 first:pt-0 last:pb-0"
            >
              <dt className="text-sm text-muted-foreground">{field.label}</dt>
              <dd className="text-sm font-medium">{field.value}</dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
}
